import { render } from "./DefecationModal.vue?vue&type=template&id=d3e4843e&ts=true"
import script from "./DefecationModal.vue?vue&type=script&lang=ts"
export * from "./DefecationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__